<template>
  <div class="container-fluid">
    <h3 class="text-dark mb-4"></h3>
    <div class="card shadow">
      <div class="card-header py-3">
        <p
          class="m-0"
          style="
            font-size: 15px;
            color: var(--bs-body-color);
            font-weight: bold;
          "
        >
          {{ $t("productcatlog") }}
          <button
            @click="UpdateClick('#add#')"
            class="btn btn-primary"
            type="button"
            style="margin: 0 0 0px 20px"
            v-if="role.updateProductCatlog"
          >
            {{ $t("addcatlog") }}
          </button>
         <span style='margin-left:50px;font-weight:normal;color:#ccc;font-size:12px'> *{{ $t("productcatlogtip") }}</span>
        </p>
      </div>
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <draggable
            v-model="DataList"
            tag="transition-group"
            item-key="name"
            handle=".handle"
            @end="onEnd"
            v-bind="dragOptions"
          >
            <template #item="{ element }">
              <li
                :key="element.name"
                style="padding: 15px; text-align: left"
                class="list-group-item"
              >
                <i class="fa fa-align-justify handle"></i>
                <img
                  onerror="javascript:this.src='data:image/svg+xml;base64,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';"
                  class="icon"
                  :src="element.icon"
                />
                <span
                  style="display: inline-block; width: 500px; margin-left: 20px"
                >
                  <a
                    style="font-size: 15px"
                    href="javascript:;"
                    @click="OpenPage(element)"
                  >
                    {{$tt(element.name) }}
                  </a>
                </span>

                <input
                  @change="OnFileChange(element)"
                  type="file"
                  class="custom-file-input"
                  :class="this.$i18n.locale == '中文' ? 'cn' : 'en'"
                />

                <a
                  href="javascript:;"
                  @click="UpdateClick(element)"
                  style="margin: 0 30px 0 45px"
                  >{{ $t("updatename") }}</a
                ><a
                  href="javascript:;"
                  @click="DeleteItem(element)"
                  style="margin: 0 30px 0"
                  >{{ $t("delete") }}</a
                >
              </li>
            </template>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
import "../common/httphelper";
import swal from "sweetalert2";
import getRole from "../common/role";
import {
  AddProductCatlog,
  DeleteProductCatlog,
  GetProductCatlog,
  SortProductCatlog,
  UpdateProductCatlog,
  UploadProductCatlogIcon,
} from "../common/httphelper";
import Swal from "sweetalert2";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      DataList: [],
      role: {},
    };
  },
  methods: {
    AddProductCatlog(name) {
      AddProductCatlog(name).then((response) => {
        if (response.data.code == 20000) {
          swal.fire({
            icon: "success",
            title: this.$t("approvetip"),
            showConfirmButton: false,
            timer: 3000,
          });
          this.$router.push("MyApprove");
          //this.RefreshList();
          return;
        } else {
          swal.fire({
            icon: "error",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },

    OpenPage(item) {
      router.push({ name: "ProductList", query: item });
    },

    DeleteItem(item) {
      Swal.fire({
        title: "确定删除吗?",
        text: "将创建删除操作的审批流程!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          DeleteProductCatlog([item.id]).then((response) => {
            if (response.data.code == 20000) {
              swal.fire({
                icon: "success",
                title: "删除操作已提交审核",
                showConfirmButton: false,
                timer: 3000,
              });
              //this.RefreshList();
              //this.$router.push('MyApprove');
              return;
            } else {
              swal.fire({
                icon: "error",
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
        }
      });
    },
    async UpdateClick(item) {
      const { value: name } = await swal.fire({
        title: "输入新的类别名称",
        input: "text",
        inputValue: item.name,
        inputPlaceholder: "产品类别",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        allowOutsideClick: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      });

      if (name) {
        if (item == "#add#") {
          this.AddProductCatlog(name);
        } else {
          let newItem = {
            name: name,
            id: item.id,
          };
          UpdateProductCatlog(newItem).then((response) => {
            if (response.data.code == 20000) {
              swal.fire({
                icon: "success",
                title: "修改操作已提交审核",
                showConfirmButton: false,
                timer: 3000,
              });
              this.RefreshList();
              //this.$router.push("MyApprove");
              return;
            } else {
              swal.fire({
                icon: "error",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      }
    },
    RefreshList() {
      GetProductCatlog().then((res) => {
        if (res.data.code == 20000) {
          this.DataList = res.data.data;
        }
      });
    },
    onEnd() {
      for (let n = 0; n < this.DataList.length; n++) {
        this.DataList[n].index = n;
      }
      let res = this.DataList.map((v) => {
        return {
          id: v.id,
          index: v.index,
        };
      });
      SortProductCatlog(res);
    },
    OnFileChange(item) {
      let reader = new FileReader();

      if (!event.target.files[0]) {
        return;
      }

      if (event.target.files[0].size > 500000) {
        Swal.fire({
          icon: "error",
          title: "图片不得大于500k",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      reader.readAsDataURL(event.target.files[0]);
      let me = this;
      reader.onload = async function (event) {
        //me.uploadImg = event.target.result;
        await UploadProductCatlogIcon({
          Id: item.id,
          DataString: event.target.result,
        });
        me.RefreshList();
      };
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this.RefreshList();
    this.role = getRole();
  },
};
</script>

<style scoped>
a {
  color: #4e73df;
  text-decoration: none;
  cursor: pointer;
}

.handle {
  float: left;
  margin-right: 15px;
  font-size: 18px;
  cursor: Move;
  line-height: 80px;
}

.icon {
  height: 80px;
  width: 80px;
}

.custom-file-input {
  color: transparent;
  width: 80px;
}
.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-file-input::before {
  color: #3071b9;
  display: inline-block;
  background: transparent;
  border: 0px;
  border-radius: 3px;
  padding: 5px 0px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
}

.cn::before {
  content: "修改图标";
}

.en::before {
  content: "Change ICON";
}

.custom-file-input:hover::before {
  border-color: black;
}
.custom-file-input:active {
  outline: 0;
}
</style>